import SFX from "@core/sfx";
import { on, off } from "@utils/listener";

const MUTED_CLASSNAME = '--muted';

class AudioButton {
  constructor(el) {
    this.el = el;

    this._ariaLabelOn = this.el.dataset.ariaOn;
    this._ariaLabelOff = this.el.dataset.ariaOff;

    this._onClick = this._onClick.bind(this);
    this._onSFXChange = this._onSFXChange.bind(this);
  }

  init() {
    this._bindEvents();

    if( SFX.muted ) this._onSFXChange();
  }
  destroy() {
    this._unbindEvents();

    this.el = null;

    this._ariaLabelOn = null;
    this._ariaLabelOff = null;

    this._onClick = null;
    this._onSFXChange = null;
  }

  _bindEvents() {
    SFX.on('change', this._onSFXChange);
    on(this.el, 'pointerdown', this._onClick);
  }
  _unbindEvents() {
    off(this.el, 'pointerdown', this._onClick);
    SFX.off('change', this._onSFXChange);
  }

  _onClick(event) {
    SFX.toggle();

    if( event && SFX.muted ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }
  _onSFXChange() {
    this.el.classList[SFX.muted ? 'add' : 'remove'](MUTED_CLASSNAME);
    this.el.setAttribute('aria-label', SFX.muted ? this._ariaLabelOff : this._ariaLabelOn);
  }
}

export default AudioButton;
